@if (trapImages$ | async; as trapImages) {
    <div class="dog-trap">
        <img fill alt="trap" [ngSrc]="getImageUrl(trapImages)" />
    </div>
}
